// extracted by mini-css-extract-plugin
export default {"about":"About_about__ZuHQW","myImg":"About_myImg__8QJZ4"};